module.exports = __webpack_public_path__ + "images/husqvarnadd3ffb7aef7af81fd41e7cec1d96aaf9.png";